import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthFacade } from '../facades/auth.facade';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

export const onboardingGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return toObservable(authFacade.isLoading).pipe(
    filter(isLoading => !isLoading),
    map(() => {
      if (!authFacade.isAuthenticated()) {
        return router.createUrlTree(['/auth/login']);
      }
      if (!authFacade.isIncompleteStudent()) {
        // Onboarding only applies to Google users with no `students` row yet.
        // Anyone else already has a landing page — dispatch by role, the same
        // way guestGuard does.
        if (authFacade.isSuperAdmin()) {
          return router.createUrlTree(['/admin']);
        }
        return router.createUrlTree([
          authFacade.isTeacher() ? '/teacher/home' : '/student/home',
        ]);
      }
      return true;
    })
  );
};
